import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogComponent } from '../../../../shared/components/dialog/dialog.component';
import { TransactionService } from '../../services/transaction.service';

@Component({
  selector: 'app-sms-resend-dialog',
  standalone: true,
  imports: [CommonModule, DialogComponent],
  templateUrl: './sms-resend-dialog.component.html',
})
export class SmsResendDialogComponent {
  @Input() show = false;
  @Input() recipientName: string | null = null;
  @Input() transactionId: number | null = null;
  @Input() showHeader: boolean = false;
  @Output() close = new EventEmitter<void>();
  @Output() confirmResend = new EventEmitter<void>();
  @Output() error = new EventEmitter<{ error?: any }>();

  constructor(private readonly transactionService: TransactionService) {}

  onCancel() {
    this.close.emit();
  }

  onConfirm() {
    if (this.transactionId) {
      this.transactionService.resendSms(this.transactionId)
      .subscribe({
          next: () => {
            this.confirmResend.emit();
          },
          error: (errorResponse) => {
            this.error.emit(errorResponse?.error);
          }
        });
    }
  }
} 